const Apartments = [
    {
        apartment: "One",
        details: "first details",
        narative: "This is a first floor apartment with an original victorian fireplace.",
        apartmentImages: [
            "https://s3.amazonaws.com/532packard/pic7.jpg",
            "https://s3.amazonaws.com/532packard/pic8.jpg"
        ]
    },
    {
        apartment: "Two",
        details: "Second details",
        narative: "This is a first floor, one bedroom apartment with a covered porch overlooking the back yard.",
        apartmentImages: [
            "https://s3.amazonaws.com/532packard/pic2.jpg",
            "https://s3.amazonaws.com/532packard/pic3.jpg"
        ]
    },
    {
        apartment: "Three",
        details: "Third details",
        narative: "This is a second floor, one bedroom apartment with a balcony looking onto Packard Street.",
        apartmentImages: [
            "https://s3.amazonaws.com/532packard/pic1.jpg",
            "https://s3.amazonaws.com/532packard/kitchen3.jpg",
            "https://s3.amazonaws.com/532packard/pic6.jpg",
            "https://s3.amazonaws.com/532packard/bedroom3.jpg"
        ]
    },
    {
        apartment: "Four",
        details: "Four details",
        narative: "This is a second floor, one bedroom apartment with a split floor plan and includes utilities.", 
        apartmentImages: [
            "https://s3.amazonaws.com/532packard/pic4.jpg",
        ]
    },
    {
        apartment: "Five",
        details: "Five details",
        narative: "This is a third floor, one bedroom apartment with cathedral ceilings and a large deck overlooking the back yard.",
        apartmentImages: [
            "https://s3.amazonaws.com/532packard/livingroom5.jpg",
            "https://s3.amazonaws.com/532packard/kitchen5.jpg",
            "https://s3.amazonaws.com/532packard/balcony5.jpg"
        ]
    }
];

export default Apartments;




// WEBPACK FOOTER //
// ./src/helpers/apartmentsFile.js